import { Component } from '@angular/core';

/**
 * 푸터 컴포넌트
 * @description 메인 레이아웃의 하단 푸터를 담당
 */
@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
})
export class FooterComponent {}
